import { io } from "socket.io-client";
import { BASE_URL } from "../app/Constants/baseConstant";

const SOCKET_URL = `${BASE_URL}:8001`;
// const SOCKET_URL = "http://localhost:8001";    // for local testing

export const socket = io(SOCKET_URL, {
  path: "/socket",
  transports: ["websocket"],
  autoConnect: false, // important
});
